import { combineReducers } from 'redux';

// All reducers from slices go here
import dashboardSlice from 'store/dashboardSlice';
import snackbarReducer from 'store/snackbarSlice';
import userReducer from 'store/userSlice';
import swipeclockUserReducer from 'store/swipeclockUserSlice';
import { companyMessagesApi } from 'src/services/companyMessages';
import { loginApi } from 'src/services/login';
import { webclockApi } from 'src/services/webclock';
import { hubApi } from 'src/services/hub';

const reducers = combineReducers({
  dashboard: dashboardSlice,
  snackbar: snackbarReducer,
  user: userReducer,
  swipeclockUser: swipeclockUserReducer,
  [companyMessagesApi.reducerPath]: companyMessagesApi.reducer,
  [loginApi.reducerPath]: loginApi.reducer,
  [webclockApi.reducerPath]: webclockApi.reducer,
  [hubApi.reducerPath]: hubApi.reducer,
});

export default reducers;
